import type { IInspector } from "./inspectors";

export enum PreferrenceType {
  PREFERRED = 'PREFERRED',
  EXCLUDED = 'EXCLUDED',
}

export interface IPersonnelPreferrence {
  id: number;
  inspectorId: number;
  type: PreferrenceType;
  projectId: number;
  inspector: IInspector;
}
